import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import Button from 'components/Buttons/Button';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  overflow-x: auto;
  padding: 16px;
  min-height: 660px;
  height: 100%;
  background-color: ${({ theme }) => theme.fullScreenToolTip.background};

  @media ${({ theme }) => theme.device.desktop} {
    background-color: ${ColorPalette.Transparent};
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Title = styled.div`
  max-width: 229px;
  font-size: 20px;
  line-height: 1.4;
  color: ${({ theme }) => theme.fullScreenToolTip.textColor};
`;

export const Icon = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 8px;
  object-fit: contain;
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  padding: 56px 28px;
`;

export const CloseIcon = styled.img`
  width: 20px;
  height: 20px;
  object-fit: contain;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding: 14px 0;
`;

export const Item: any = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 32px;
`;

Item.IconContainer = styled.div`
  width: 102px;
  min-height: 102px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  margin-bottom: 16px;
  border: solid 1px ${({ theme }) => theme.fullScreenToolTip.imageBorder};
`;

Item.Icon = styled.img`
  max-height: 56px;
  object-fit: contain;
`;

Item.Text = styled.div`
  font-size: 14px;
  line-height: 1.43;
  color: ${({ theme }) => theme.fullScreenToolTip.textColor};
`;

export const ButtonContainer = styled.div`
  position: fixed;
  padding: 16px;
  bottom: 0;
  right: 0;
  left: 0;
`;

export const StyledButton = styled(Button)`
  font-size: 16px;
  height: 56px;
`;
